module.exports = __webpack_public_path__ + "static/shanna-teel-bio-2afe36179dc38120a11860d0666359dd.jpg";